// @flow
import React, { useState, useCallback } from 'react';

import { navigate } from '../../lib/helpers';
import { vehicleTaxMapApi } from '../../lib/api';
import { type VehicleTaxMap } from '../../lib/types';

import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import { InnerForm } from './components';
import { getBreadCrumbsByUrlForEdit } from '../../lib/autoBreadcrumbs';

type PageProps = {
  id: number
};

const entryPointPath = '/admin/vehicle-tax-map/';

export default (props: PageProps) => {
  const [data: VehicleTaxMap, setData] = useState({
    id: props.id
  });

  const breadCrumbs = getBreadCrumbsByUrlForEdit(entryPointPath, props.id);

  const onFetch = useCallback(async () => {
    !!props.id && setData(await vehicleTaxMapApi.get(props.id));
  }, [props.id]);

  const onSubmit = async (payload: VehicleTaxMap) => {
    let id = payload.id;
    if (id) {
      await vehicleTaxMapApi.update(payload);
    } else {
      let data = await vehicleTaxMapApi.add(payload);
      id = data.id;
    }
    await navigate(`${entryPointPath}`);
  };

  const onCancel = async (payload: VehicleTaxMap) => {
    if (data.id) {
      await navigate(`${entryPointPath}${data.id}`);
    } else await navigate(`${entryPointPath}`, true);
  };

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader: 'Соответствие объекта налогообложения и категории ТС'
      }}
      onFetch={onFetch}
      onSubmit={onSubmit}
      onCancel={onCancel}
    >
      <InnerForm data={data} useFooter noWrapMe />
    </CommonCardPage>
  );
};
